import {Inject, Injectable, InjectionToken, Optional} from '@angular/core';
import * as _ from 'lodash-es';
import {WidgetDescription} from './widget-description';

/**
 * Provides list of all known widget descriptions.
 * @example
 *  providers: [
 *      {
 *          provide: WIDGET_DESCRIPTION,
 *          useValue: QUOTES_WIDGET_DESCRIPTION,
 *          multi: true
 *      }
 *  ]
 */
export const WIDGET_DESCRIPTIONS = new InjectionToken<WidgetDescription[]>('WidgetDescriptions', {
    factory: () => []
});

@Injectable()
export class WidgetRegistryService {

    private static createWidgetDescriptionDict(
        widgetDescriptions: WidgetDescription[]
    ): {[widgetTypeId: string]: WidgetDescription} {
        return _.keyBy(
            widgetDescriptions,
            widgetDescription => widgetDescription.widgetTypeId
        );
    }

    private readonly widgetDescriptionDict: {[widgetTypeId: string]: WidgetDescription};

    constructor(
        @Optional()
        @Inject(WIDGET_DESCRIPTIONS)
        private readonly widgetDescriptions: WidgetDescription[]
    ) {
        this.widgetDescriptions = this.widgetDescriptions || [];
        this.widgetDescriptionDict = WidgetRegistryService.createWidgetDescriptionDict(this.widgetDescriptions);
    }

    public getWidgetDescription(widgetTypeId: string): WidgetDescription {
        return this.widgetDescriptionDict[widgetTypeId];
    }

}
